import fetcher from '../utils/api';

const reactionService = {
  // This will try to use authentication but if it's not there will gracefully fail. Requests need not be authenticated for public scribes.
  create: async (reactionIdentifier: string, docId: string) => {
    return fetcher(`reactions/${docId}/`, 'POST', true, { identifier: reactionIdentifier });
  },
  getReactionsForDoc: async (docId: string, superOrganizationId = '') => {
    return fetcher(`reactions/${docId}/?${superOrganizationId ? `super_organization_id=${superOrganizationId}` : ''}`, 'GET', false);
  },
  getUserReactionForDoc: async (docId: string, authenticated: boolean) => {
    return fetcher(`reactions/${docId}/my_reaction/`, 'GET', authenticated);
  },
  delete: async (reactionId: string, docId: string) => {
    return fetcher(`reactions/${docId}/${reactionId}/`, 'DELETE', true);
  },
  update: async (reactionId: string, docId: string, reaction: string) => {
    return fetcher(`reactions/${docId}/${reactionId}/`, 'PUT', true, { identifier: reaction });
  }
};

export default reactionService;
